import socket from '@/services/socket.service';

function handleAccessPermissionToRoute(store, to, callback) {
  const pathThatRequiresSpecificPermissionAccess = to.matched.some(record => record.meta.permissionAccessType !== undefined);

  if (!pathThatRequiresSpecificPermissionAccess) {
    callback();
    return;
  }

  if (store.getters['authorization/acl'].hasPermission(to.meta?.permissionAccessType)) {
    callback();
    return;
  }

  callback('/403');
}

function handleCheckIsSocketConnected(to, callback) {
  const pathThatRequiresAuthSocket = to.matched.some(record => record.meta.requiresAuthorizationSocket);
  if (!pathThatRequiresAuthSocket) {
    callback();
  } else {
    setTimeout(() => {
      if (!socket.isSocketConnected()) {
        callback('/connections');
      } else {
        callback();
      }
    }, 100);
  }
}

export default (router, API, store, options) => {
  const pathWithLogin = router.options.routes.find(
    record => record.meta.authorizationType === 'login',
  );

  router.beforeEach(async (to, from, next) => {
    const pathThatRequiresAuth = to.matched.some(record => record.meta.requiresAuthentication);
    const sessionEndpoint = { endpoint: options.endpoints.session };
    const pathThatRequiresActiveProject = to.matched.some(record => record.meta.requiresUnlessOneActiveProject);
    const isAuthenticated = await checkIfUserIsAuthenticated(sessionEndpoint);
    if (pathThatRequiresActiveProject && to.path === '/connections' && isAuthenticated) {
      (async () => {
        await store.dispatch('client/projects/getList');
        const projectsList = store.getters['client/projects/list'].records;
        if (!projectsList.length) {
          next({ path: '/204' });
        } else {
          next();
        }
      })();
    }
    if (pathThatRequiresAuth) {
      (async () => {
        if (isAuthenticated) {
          handleAccessPermissionToRoute(store, to, next);
          handleCheckIsSocketConnected(to, next);
        } else {
          next(pathWithLogin);
        }
      })();
    } else if (to.name === pathWithLogin.name) {
      (async () => {
        API.removeResponseInterceptor();
        if (isAuthenticated) {
          next(options.pathAfterLogin);
        } else {
          next();
        }
      })();
    } else {
      next();
    }
  });

  async function checkIfUserIsAuthenticated(sessionEndpoint) {
    await store.dispatch('authorization/checkIfUserSessionExists', sessionEndpoint);
    return store.getters['authorization/isAuthenticated'];
  }
};
